export default __webpack_public_path__ + "static/media/feature--import.f4fdeb9d.png";